/* =====================================================================
   BYON · Home (ronda 10, 24-sep-2026) · agente Home
   - Hero: puntos y flechas (sin autoplay), orden de slides programados,
     cuenta regresiva en hora de Chile, vista previa de slides programados
     en el editor de temas.
   - Reseñas: recorte con "Ver más reseñas".
   - R1: data-byon-promo en los "Ver todos" de las colecciones destacadas nativas (K1).
   - 1-oct-2026: en computador las flechas de los carruseles avanzan una página.
   Se puede cargar más de una vez en la página (varias secciones lo piden):
   solo se inicializa una vez; en el editor se re-inicializa por sección.
   ===================================================================== */
(function () {
  'use strict';
  if (window.BYONHome) return;

  var RE = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* Fecha y hora actuales en Chile, "AAAA-MM-DD HH:MM". ?byon_now=... la simula (QA). */
  function nowCL() {
    if (typeof window.byonNowCL === 'function') return window.byonNowCL();
    var m = location.search.match(/[?&]byon_now=([^&]+)/);
    if (m) {
      var q = decodeURIComponent(m[1].replace(/\+/g, ' '));
      if (RE.test(q)) return q;
    }
    try {
      var p = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date())
        .forEach(function (x) { p[x.type] = x.value; });
      return p.year + '-' + p.month + '-' + p.day + ' ' + (p.hour === '24' ? '00' : p.hour) + ':' + p.minute;
    } catch (e) {
      return null;
    }
  }

  /* "AAAA-MM-DD HH:MM" (hora de pared) → minutos comparables (UTC ficticio; ambos lados en hora de Chile) */
  function toMinutes(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2})$/.exec(s || '');
    if (!m) return NaN;
    return Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]) / 60000;
  }

  /* ---------------- Hero ---------------- */
  function applySchedule(root) {
    var now = nowCL();
    if (!now) return;
    var slides = root.querySelectorAll('[data-slide][data-sched]');
    for (var i = 0; i < slides.length; i++) {
      var s = slides[i];
      if (s.hasAttribute('data-editor-shown')) continue;
      var a = s.getAttribute('data-start') || '';
      var b = s.getAttribute('data-end') || '';
      var on = (!a || (RE.test(a) && now >= a)) && (!b || (RE.test(b) && now <= b));
      s.hidden = !on;
      s.style.order = on ? '-1' : '';
    }
  }

  function visibleSlides(track) {
    var all = [].slice.call(track.querySelectorAll('[data-slide]'));
    return all
      .map(function (el, i) { return { el: el, i: i, o: parseInt(el.style.order || '0', 10) || 0 }; })
      .filter(function (x) { return !x.el.hidden; })
      .sort(function (a, b) { return (a.o - b.o) || (a.i - b.i); })
      .map(function (x) { return x.el; });
  }

  function initHero(root) {
    if (!root || root.__byonHero) return;
    root.__byonHero = true;
    applySchedule(root);

    var track = root.querySelector('[data-hero-track]');
    var nav = root.querySelector('[data-hero-nav]');
    var dotsWrap = root.querySelector('[data-hero-dots]');
    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (!track) return;

    var vis = [];
    var dots = [];

    function current() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(vis.length - 1, Math.round(track.scrollLeft / w)));
    }
    function go(i) {
      if (!vis.length) return;
      i = Math.max(0, Math.min(vis.length - 1, i));
      track.scrollTo({ left: vis[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    function update() {
      var c = current();
      dots.forEach(function (d, i) {
        if (i === c) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = c <= 0;
      if (next) next.disabled = c >= vis.length - 1;
    }
    function build() {
      vis = visibleSlides(track);
      vis.forEach(function (s, i) {
        if (s.hasAttribute('aria-roledescription')) s.setAttribute('aria-label', (i + 1) + ' de ' + vis.length);
      });
      dots = [];
      if (dotsWrap) dotsWrap.innerHTML = '';
      root.classList.toggle('byon-hero--single', vis.length < 2);
      if (!nav || vis.length < 2) {
        if (nav) nav.hidden = true;
        return;
      }
      vis.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'byon-hero__dot';
        b.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1) + ' de ' + vis.length);
        b.addEventListener('click', function () { go(i); });
        dotsWrap.appendChild(b);
        dots.push(b);
      });
      nav.hidden = false;
      update();
    }

    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { go(current() + 1); }
      else if (e.key === 'ArrowLeft') { go(current() - 1); }
    });
    window.addEventListener('resize', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    });

    root.__byonHeroRebuild = function () { applySchedule(root); build(); };
    build();
    /* Al cargar se ve el primer slide: si un slide programado apareció después de que el navegador
       ubicó el carrusel, este quedó en otro slide */
    if (vis.length > 1 && Math.abs(track.scrollLeft - vis[0].offsetLeft) > 1) {
      try { track.scrollTo({ left: vis[0].offsetLeft, behavior: 'instant' }); } catch (e) { track.scrollLeft = vis[0].offsetLeft; }
      update();
    }
    initCountdowns(root);
  }

  function initCountdowns(root) {
    var els = [].slice.call(root.querySelectorAll('[data-countdown-to]'));
    if (!els.length) return;
    function tick() {
      var now = toMinutes(nowCL());
      els.forEach(function (el) {
        var target = toMinutes(el.getAttribute('data-countdown-to'));
        var out = el.querySelector('[data-countdown-value]');
        if (isNaN(now) || isNaN(target) || !out) { el.hidden = true; return; }
        var mins = target - now;
        if (mins <= 0) { el.hidden = true; return; }
        var d = Math.floor(mins / 1440);
        var h = Math.floor((mins % 1440) / 60);
        var mi = Math.floor(mins % 60);
        out.textContent = (d > 0 ? d + (d === 1 ? ' día ' : ' días ') : '') + pad(h) + ' h ' + pad(mi) + ' min';
        el.hidden = false;
      });
    }
    tick();
    root.__byonCountdown && clearInterval(root.__byonCountdown);
    root.__byonCountdown = setInterval(tick, 30000);
  }

  /* ---------------- Reseñas: recorte + "Ver más reseñas" ---------------- */
  function initCollapse(box) {
    if (!box || box.__byonCollapse) return;
    box.__byonCollapse = true;
    var inner = box.querySelector('[data-collapse-inner]');
    var btn = document.querySelector('[data-collapse-toggle][aria-controls="' + box.id + '"]');
    if (!inner || !btn) return;
    var mq = window.matchMedia('(min-width: 990px)');

    function limit() {
      var v = getComputedStyle(box).getPropertyValue(mq.matches ? '--byon-collapse-h-d' : '--byon-collapse-h');
      return parseInt(v, 10) || 600;
    }
    /* El recorte rige por CSS desde el primer pintado. Aquí: degradado + botón si sobra más de 80 px;
       si sobra menos, se libera (is-short) para no cortar sin botón. */
    function check() {
      if (box.classList.contains('is-expanded')) return;
      var h = inner.scrollHeight;
      var lim = limit();
      var need = h > lim + 80;
      box.classList.toggle('is-collapsible', need);
      box.classList.toggle('is-short', !need && h > lim);
      btn.hidden = !need;
    }
    btn.addEventListener('click', function () {
      var expanded = !box.classList.contains('is-expanded');
      box.classList.toggle('is-expanded', expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? (btn.getAttribute('data-less') || 'Ver menos') : (btn.getAttribute('data-more') || 'Ver más reseñas');
      if (!expanded) {
        check();
        var top = box.getBoundingClientRect().top + window.pageYOffset - 120;
        window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    });
    if ('ResizeObserver' in window) {
      new ResizeObserver(check).observe(inner);
    }
    /* Loox fija el alto de su iframe por atributo: esto también avisa en pestañas sin pintar */
    if ('MutationObserver' in window) {
      new MutationObserver(check).observe(inner, { subtree: true, childList: true, attributes: true, attributeFilter: ['style', 'height'] });
    }
    window.addEventListener('load', check);
    if (mq.addEventListener) mq.addEventListener('change', check);
    check();
  }

  /* ---------------- Medición (K1): "Ver todos" de las "Colección destacada" nativas ----------------
     El richtext de la descripción no admite data-*: se agregan aquí. El evento lo emite byon-global.js (Base). */
  function tagViewAll(scope) {
    var secs = scope.matches && scope.matches('[id*="__byon_fc_"]') ? [scope] : scope.querySelectorAll('.shopify-section[id*="__byon_fc_"]');
    [].forEach.call(secs, function (sec) {
      var key = sec.id.split('__').pop();
      var title = sec.querySelector('.collection__title .title');
      var name = title ? title.textContent.replace(/\s+/g, ' ').trim() : key;
      [].forEach.call(sec.querySelectorAll('.collection__description a[href]'), function (a) {
        if (!a.hasAttribute('data-byon-promo')) a.setAttribute('data-byon-promo', 'home_viewall_' + key);
        if (!a.hasAttribute('data-byon-promo-name')) a.setAttribute('data-byon-promo-name', name.slice(0, 60));
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    [].forEach.call(scope.querySelectorAll('[data-byon-hero]'), initHero);
    [].forEach.call(scope.querySelectorAll('[data-byon-collapse]'), initCollapse);
    tagViewAll(scope);
  }

  /* ---------------- Carruseles de producto en computador (1-oct-2026, feedback de Tania) ----------------
     byon-home.css (3b) pone las flechas a los costados. Desde 990 px cada clic avanza las tarjetas que se ven
     (una "página") en vez de una sola: SliderComponent.onButtonClick (global.js) lee data-step del botón y este
     listener, en fase de captura, lo fija justo antes. Celular y tablet siguen de a una tarjeta. */
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 990px)') : null;
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.shopify-section[id*="__byon_fc_"] .slider-button') : null;
    if (!btn) return;
    var step = 1;
    var sc = mqDesk && mqDesk.matches ? btn.closest('slider-component') : null;
    var ul = sc ? sc.querySelector('.slider') : null;
    if (ul) {
      var items = [].filter.call(ul.children, function (li) { return li.clientWidth > 0; });
      if (items.length > 1) {
        var off = items[1].offsetLeft - items[0].offsetLeft;
        var gap = off - items[0].clientWidth;
        if (off > 0) step = Math.max(1, Math.floor((ul.clientWidth + gap + 2) / off));
      }
    }
    btn.setAttribute('data-step', String(step));
  }, true);

  window.BYONHome = { init: init, nowCL: nowCL };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  /* Editor de temas: re-inicializar al recargar una sección y mostrar un slide programado al seleccionarlo */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches('[data-slide]')) return;
    var root = s.closest('[data-byon-hero]');
    if (s.hidden) { s.hidden = false; s.setAttribute('data-editor-shown', ''); }
    if (root && root.__byonHeroRebuild) root.__byonHeroRebuild();
    var track = s.parentElement;
    if (track) track.scrollTo({ left: s.offsetLeft, behavior: 'auto' });
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var s = e.target;
    if (!s || !s.hasAttribute || !s.hasAttribute('data-editor-shown')) return;
    s.removeAttribute('data-editor-shown');
    var root = s.closest('[data-byon-hero]');
    if (root && root.__byonHeroRebuild) root.__byonHeroRebuild();
  });
})();
